import { Box, Typography } from '@mui/material';
import type { LucideIcon } from 'lucide-react';

import { customPalette } from '@shared/theme/StyleProvider';

const DrawerEmptyState = ({
  icon: Icon,
  message,
}: {
  icon: LucideIcon;
  message: string;
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        py: 4,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1.5,
      }}
    >
      <Icon size={32} color={customPalette.gray400} strokeWidth={1.5} />
      <Typography variant="body2" sx={{ color: 'text.disabled' }}>
        {message}
      </Typography>
    </Box>
  );
};

export default DrawerEmptyState;
